import { PropertiesStore } from '@hortplus/properties-react';
import { Formik } from 'formik';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Fragment, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import LoadingOverlay from '../LoadingOverlay';
import { useStores } from '../stores/useStores';
import AddTrappingZoneForm from './AddTrappingZoneForm';

function AddTrappingZoneModal(props) {
  const { traplogStore } = useStores();
  const [show, setShow] = useState(false);
  const [boundary, setBoundary] = useState(null);

  const modalOptions = props.customOptions?.modal;

  const hide = () => {
    setShow(false);
  };

  return (
    <Fragment>
      <Button type='button' variant='link' onClick={() => setShow(true)}>
        Add Production Site
      </Button>
      <Modal show={show} backdrop='static' onHide={() => hide()}>
        <Modal.Header closeButton>
          <Modal.Title>Add Production Site</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            validateOnChange={false}
            validateOnBlur={false}
            validateOnMount={false}
            initialValues={{
              // react-select values
              matingDisruptionTie: '',

              // Regular inputs
              property_id: props.propertiesStore.selectedPropertyId,
              name: '',
              cmsm: false,
              high_risk: false
            }}
            validate={(values, props) => {
              const errors = {};

              if (values.property_id === null)
                errors.matingDisruptionTie = 'Required';
              if (!values.name) errors.name = 'Required';
              return errors;
            }}
            onSubmit={(values, actions) => {
              if (props.map) {
                if (!boundary) {
                  actions.setSubmitting(false);
                  return;
                }
              }
              const geometry = boundary?.geometry;
              fetch(
                `${process.env.REACT_APP_TRAPLOG_API_URL}api/trapping-zones`,
                {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                    Authorization: `Bearer ${props.bearerToken}`,
                    SeasonalDatabase: props.selectedDatabase
                  },
                  body: JSON.stringify({
                    property_id: values.property_id,
                    mating_disruption_tie_id: values.matingDisruptionTie
                      ? values.matingDisruptionTie.value
                      : null,
                    name: values.name,
                    cmsm: values.cmsm,
                    high_risk: values.high_risk,
                    boundry: geometry ? JSON.stringify(geometry) : null
                  })
                }
              )
                .then((res) => {
                  if (res.ok) return res.json();
                  else if (res.status === 401) props.refreshBearerToken();
                  else throw Error(res.statusText);
                })
                .then((data) => {
                  traplogStore.loadTrappingZones(
                    props.bearerToken,
                    props.refreshBearerToken,
                    props.selectedDatabase,
                    props.propertiesStore.selectedPropertyId
                  );
                  hide();
                  traplogStore.setSelectedTrappingZoneId(data.id);
                })
                .catch((err) => {
                  if (process.env.NODE_ENV === 'development')
                    console.error(err);
                })
                .finally(() => {
                  actions.setSubmitting(false);
                });
            }}
          >
            {(fProps) => (
              <Fragment>
                <AddTrappingZoneForm
                  {...fProps}
                  setBoundary={setBoundary}
                  map={props.map}
                  customOptions={modalOptions}
                />
                {fProps.isSubmitting ? <LoadingOverlay /> : null}
              </Fragment>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
}

AddTrappingZoneModal.propTypes = {
  map: PropTypes.bool,
  selectedDatabase: PropTypes.string.isRequired,
  bearerToken: PropTypes.string.isRequired,
  refreshBearerToken: PropTypes.func.isRequired,
  propertiesStore: PropTypes.instanceOf(PropertiesStore).isRequired,
  customOptions: PropTypes.object
};

export default observer(AddTrappingZoneModal);
